module.exports = __webpack_public_path__ + "img/Charity&Gifts.8cae657e.svg";